import { createEntityAdapter } from '@reduxjs/toolkit';
import { ICustomer } from '../types/api';
import { IState } from '../types/reducer';

export const customerDetailAdapter = createEntityAdapter<ICustomer>();
export const customerDetailSelectors = customerDetailAdapter.getSelectors<IState>(state => state.popoverCustomerDetailCache);
